import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ea3cc0fa")

_pushScopeId("data-v-ea3cc0fa")
const _hoisted_1 = {
  class: "c-sidebar c-sidebar-dark c-sidebar-fixed c-sidebar-lg-show",
  id: "sidebar"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "c-sidebar-brand-full",
  height: "40",
  src: "/img/logo.png"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "c-sidebar-brand-minimized",
  height: "400",
  src: "/img/logo.png"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  어신 백오피스 ")
const _hoisted_5 = { class: "c-sidebar-nav" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h2", { class: "c-sidebar-nav-header" }, [
  /*#__PURE__*/_createTextVNode(" 운영 "),
  /*#__PURE__*/_createVNode("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 129",
    width: "12",
    height: "12",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "enable-background": "new 0 0 129 129"
  }, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("path", {
        d: "M7.7,94.4c1.6,1.6,4.2,1.6,5.8,0l51-51.1l51.1,51.1c1.6,1.6,4.2,1.6,5.8,0c1.6-1.6,1.6-4.2,0-5.8L67.5,34.7c-0.8-0.8-1.8-1.2-2.9-1.2c-1,0-2.1,0.4-2.9,1.2L7.7,88.6C6,90.2,6,92.8,7.7,94.4z",
        fill: "#FFFFFF80"
      })
    ])
  ])
], -1)
const _hoisted_7 = { class: "c-sidebar-nav-title" }
const _hoisted_8 = { class: "c-sidebar-nav-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-bell" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 공지 ")
const _hoisted_11 = { class: "c-sidebar-nav-item" }
const _hoisted_12 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-newspaper" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 포스트 ")
const _hoisted_14 = { class: "c-sidebar-nav-item" }
const _hoisted_15 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-newspaper" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 포스트 카테고리 ")
const _hoisted_17 = { class: "c-sidebar-nav-item" }
const _hoisted_18 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/brand.svg#cib-instagram" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 피싱그램 ")
const _hoisted_20 = { class: "c-sidebar-nav-item" }
const _hoisted_21 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/brand.svg#cib-instagram" })
], -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 피싱그램 베스트 ")
const _hoisted_23 = { class: "c-sidebar-nav-item" }
const _hoisted_24 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-address-book" })
], -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 어신 사이렌 ")
const _hoisted_26 = { class: "c-sidebar-nav-item" }
const _hoisted_27 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-address-book" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 어신 매거진 ")
const _hoisted_29 = { class: "c-sidebar-nav-item" }
const _hoisted_30 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-address-book" })
], -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 어신 매거진 카테고리 ")
const _hoisted_32 = { class: "c-sidebar-nav-item" }
const _hoisted_33 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-location-pin" })
], -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 바다 포인트 ")
const _hoisted_35 = { class: "c-sidebar-nav-item" }
const _hoisted_36 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-location-pin" })
], -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 민물 포인트 ")
const _hoisted_38 = { class: "c-sidebar-nav-item" }
const _hoisted_39 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-location-pin" })
], -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 관측소 포인트 ")
const _hoisted_41 = { class: "c-sidebar-nav-item" }
const _hoisted_42 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-user-x" })
], -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 매듭 관리 ")
const _hoisted_44 = { class: "c-sidebar-nav-item" }
const _hoisted_45 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-user-x" })
], -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 매듭 카테고리 관리 ")
const _hoisted_47 = { class: "c-sidebar-nav-item" }
const _hoisted_48 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-send" })
], -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 앱 푸시 ")
const _hoisted_50 = /*#__PURE__*/_createVNode("h2", { class: "c-sidebar-nav-header" }, [
  /*#__PURE__*/_createTextVNode(" 어신 청약몰 관리 "),
  /*#__PURE__*/_createVNode("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 129",
    width: "12",
    height: "12",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "enable-background": "new 0 0 129 129"
  }, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("path", {
        d: "M7.7,94.4c1.6,1.6,4.2,1.6,5.8,0l51-51.1l51.1,51.1c1.6,1.6,4.2,1.6,5.8,0c1.6-1.6,1.6-4.2,0-5.8L67.5,34.7c-0.8-0.8-1.8-1.2-2.9-1.2c-1,0-2.1,0.4-2.9,1.2L7.7,88.6C6,90.2,6,92.8,7.7,94.4z",
        fill: "#FFFFFF80"
      })
    ])
  ])
], -1)
const _hoisted_51 = { class: "c-sidebar-nav-title" }
const _hoisted_52 = { class: "c-sidebar-nav-item" }
const _hoisted_53 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-address-book" })
], -1)
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" 어신 청약몰 ")
const _hoisted_55 = /*#__PURE__*/_createVNode("h2", { class: "c-sidebar-nav-header" }, [
  /*#__PURE__*/_createTextVNode(" 파트너스 관리 "),
  /*#__PURE__*/_createVNode("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 129",
    width: "12",
    height: "12",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "enable-background": "new 0 0 129 129"
  }, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("path", {
        d: "M7.7,94.4c1.6,1.6,4.2,1.6,5.8,0l51-51.1l51.1,51.1c1.6,1.6,4.2,1.6,5.8,0c1.6-1.6,1.6-4.2,0-5.8L67.5,34.7c-0.8-0.8-1.8-1.2-2.9-1.2c-1,0-2.1,0.4-2.9,1.2L7.7,88.6C6,90.2,6,92.8,7.7,94.4z",
        fill: "#FFFFFF80"
      })
    ])
  ])
], -1)
const _hoisted_56 = { class: "c-sidebar-nav-title" }
const _hoisted_57 = { class: "c-sidebar-nav-item" }
const _hoisted_58 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" 파트너스 관리 ")
const _hoisted_60 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-bell" })
], -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" 부킹 정산 관리 ")
const _hoisted_62 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" 상품 ")
const _hoisted_64 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" 조황일지 ")
const _hoisted_66 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-bell" })
], -1)
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 고객센터 공지사항 ")
const _hoisted_68 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-bell" })
], -1)
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" 파트너스 포스트 ")
const _hoisted_70 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-bell" })
], -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" 파트너스 포스트 카테고리 ")
const _hoisted_72 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 어종 코드 ")
const _hoisted_74 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-equalizer" })
], -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" 공통 코드 ")
const _hoisted_76 = /*#__PURE__*/_createVNode("h2", { class: "c-sidebar-nav-header" }, [
  /*#__PURE__*/_createTextVNode(" 어신 커머스 관리 "),
  /*#__PURE__*/_createVNode("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 129",
    width: "12",
    height: "12",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "enable-background": "new 0 0 129 129"
  }, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("path", {
        d: "M7.7,94.4c1.6,1.6,4.2,1.6,5.8,0l51-51.1l51.1,51.1c1.6,1.6,4.2,1.6,5.8,0c1.6-1.6,1.6-4.2,0-5.8L67.5,34.7c-0.8-0.8-1.8-1.2-2.9-1.2c-1,0-2.1,0.4-2.9,1.2L7.7,88.6C6,90.2,6,92.8,7.7,94.4z",
        fill: "#FFFFFF80"
      })
    ])
  ])
], -1)
const _hoisted_77 = { class: "c-sidebar-nav-title" }
const _hoisted_78 = { class: "c-sidebar-nav-item" }
const _hoisted_79 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-address-book" })
], -1)
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" 셀러 관리 ")
const _hoisted_81 = { class: "c-sidebar-nav-item" }
const _hoisted_82 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" 상품 관리 ")
const _hoisted_84 = { class: "c-sidebar-nav-item" }
const _hoisted_85 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" 상품 카테고리 관리 ")
const _hoisted_87 = { class: "c-sidebar-nav-item" }
const _hoisted_88 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" 상품 프로모션 관리 ")
const _hoisted_90 = { class: "c-sidebar-nav-item" }
const _hoisted_91 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" 상품 주문 관리 ")
const _hoisted_93 = { class: "c-sidebar-nav-item" }
const _hoisted_94 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" 미발주 현황 ")
const _hoisted_96 = { class: "c-sidebar-nav-item" }
const _hoisted_97 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" 발주 현황 ")
const _hoisted_99 = /*#__PURE__*/_createVNode("h2", { class: "c-sidebar-nav-header" }, [
  /*#__PURE__*/_createTextVNode(" 사용자 관리 "),
  /*#__PURE__*/_createVNode("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 129",
    width: "12",
    height: "12",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "enable-background": "new 0 0 129 129"
  }, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("path", {
        d: "M7.7,94.4c1.6,1.6,4.2,1.6,5.8,0l51-51.1l51.1,51.1c1.6,1.6,4.2,1.6,5.8,0c1.6-1.6,1.6-4.2,0-5.8L67.5,34.7c-0.8-0.8-1.8-1.2-2.9-1.2c-1,0-2.1,0.4-2.9,1.2L7.7,88.6C6,90.2,6,92.8,7.7,94.4z",
        fill: "#FFFFFF80"
      })
    ])
  ])
], -1)
const _hoisted_100 = { class: "c-sidebar-nav-title" }
const _hoisted_101 = { class: "c-sidebar-nav-item" }
const _hoisted_102 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-address-book" })
], -1)
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" 사용자 관리 ")
const _hoisted_104 = { class: "c-sidebar-nav-item" }
const _hoisted_105 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-address-book" })
], -1)
const _hoisted_106 = /*#__PURE__*/_createTextVNode(" 어신 등급 사용자 관리 ")
const _hoisted_107 = { class: "c-sidebar-nav-item" }
const _hoisted_108 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-address-book" })
], -1)
const _hoisted_109 = /*#__PURE__*/_createTextVNode(" 사용자 신고 ")
const _hoisted_110 = /*#__PURE__*/_createVNode("h2", { class: "c-sidebar-nav-header" }, [
  /*#__PURE__*/_createTextVNode(" 관리자 관리 "),
  /*#__PURE__*/_createVNode("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 129",
    width: "12",
    height: "12",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "enable-background": "new 0 0 129 129"
  }, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("path", {
        d: "M7.7,94.4c1.6,1.6,4.2,1.6,5.8,0l51-51.1l51.1,51.1c1.6,1.6,4.2,1.6,5.8,0c1.6-1.6,1.6-4.2,0-5.8L67.5,34.7c-0.8-0.8-1.8-1.2-2.9-1.2c-1,0-2.1,0.4-2.9,1.2L7.7,88.6C6,90.2,6,92.8,7.7,94.4z",
        fill: "#FFFFFF80"
      })
    ])
  ])
], -1)
const _hoisted_111 = { class: "c-sidebar-nav-title" }
const _hoisted_112 = { class: "c-sidebar-nav-item" }
const _hoisted_113 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-user-x" })
], -1)
const _hoisted_114 = /*#__PURE__*/_createTextVNode(" 관리자 계정 ")
const _hoisted_115 = { class: "c-sidebar-nav-item" }
const _hoisted_116 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-https" })
], -1)
const _hoisted_117 = /*#__PURE__*/_createTextVNode(" 관리자 권한 ")
const _hoisted_118 = /*#__PURE__*/_createVNode("h2", { class: "c-sidebar-nav-header" }, [
  /*#__PURE__*/_createTextVNode(" 리워드 관리 "),
  /*#__PURE__*/_createVNode("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 129",
    width: "12",
    height: "12",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "enable-background": "new 0 0 129 129"
  }, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("path", {
        d: "M7.7,94.4c1.6,1.6,4.2,1.6,5.8,0l51-51.1l51.1,51.1c1.6,1.6,4.2,1.6,5.8,0c1.6-1.6,1.6-4.2,0-5.8L67.5,34.7c-0.8-0.8-1.8-1.2-2.9-1.2c-1,0-2.1,0.4-2.9,1.2L7.7,88.6C6,90.2,6,92.8,7.7,94.4z",
        fill: "#FFFFFF80"
      })
    ])
  ])
], -1)
const _hoisted_119 = { class: "c-sidebar-nav-title" }
const _hoisted_120 = { class: "c-sidebar-nav-item" }
const _hoisted_121 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-briefcase" })
], -1)
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" 공통 코드 ")
const _hoisted_123 = /*#__PURE__*/_createVNode("h2", { class: "c-sidebar-nav-header" }, [
  /*#__PURE__*/_createTextVNode(" 서비스 중지 메뉴 "),
  /*#__PURE__*/_createVNode("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 129",
    width: "12",
    height: "12",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "enable-background": "new 0 0 129 129"
  }, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("path", {
        d: "M7.7,94.4c1.6,1.6,4.2,1.6,5.8,0l51-51.1l51.1,51.1c1.6,1.6,4.2,1.6,5.8,0c1.6-1.6,1.6-4.2,0-5.8L67.5,34.7c-0.8-0.8-1.8-1.2-2.9-1.2c-1,0-2.1,0.4-2.9,1.2L7.7,88.6C6,90.2,6,92.8,7.7,94.4z",
        fill: "#FFFFFF80"
      })
    ])
  ])
], -1)
const _hoisted_124 = { class: "c-sidebar-nav-title" }
const _hoisted_125 = { class: "c-sidebar-nav-item" }
const _hoisted_126 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/brand.svg#cib-youtube" })
], -1)
const _hoisted_127 = /*#__PURE__*/_createTextVNode(" 피싱 유튜브 ")
const _hoisted_128 = { class: "c-sidebar-nav-item" }
const _hoisted_129 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-book" })
], -1)
const _hoisted_130 = /*#__PURE__*/_createTextVNode(" 이전 포스트 ")
const _hoisted_131 = { class: "c-sidebar-nav-item" }
const _hoisted_132 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-book" })
], -1)
const _hoisted_133 = /*#__PURE__*/_createTextVNode(" 이전 포스트 카테고리 ")
const _hoisted_134 = { class: "c-sidebar-nav-item" }
const _hoisted_135 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-book" })
], -1)
const _hoisted_136 = /*#__PURE__*/_createTextVNode(" 어신 토크 ")
const _hoisted_137 = { class: "c-sidebar-nav-item" }
const _hoisted_138 = /*#__PURE__*/_createVNode("svg", { class: "c-sidebar-nav-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-book" })
], -1)
const _hoisted_139 = /*#__PURE__*/_createTextVNode(" 어신 토크 카테고리 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "c-sidebar-brand d-lg-down-none pointer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
    }, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    _createVNode("nav", _hoisted_5, [
      _hoisted_6,
      _createVNode("ul", _hoisted_7, [
        _createVNode("li", _hoisted_8, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'Notifications' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('Notifications') ? 'hidden' : '',
            ]],
            to: "/notifications"
          }, {
            default: _withId(() => [
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_11, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'Post' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('Post') ? 'hidden' : '',
            ]],
            to: "/post"
          }, {
            default: _withId(() => [
              _hoisted_12,
              _hoisted_13
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_14, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'PostCategories' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('PostCategories') ? 'hidden' : '',
            ]],
            to: "/post-categories"
          }, {
            default: _withId(() => [
              _hoisted_15,
              _hoisted_16
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_17, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'FishingGrams' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('FishingGrams') ? 'hidden' : '',
            ]],
            to: "/fishing-grams"
          }, {
            default: _withId(() => [
              _hoisted_18,
              _hoisted_19
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_20, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'FishingGramsBestCandidates'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              !_ctx.permissions.includes('FishingGramsBestCandidates')
                ? 'hidden'
                : '',
            ]],
            to: "/fishing-grams-best-candidates"
          }, {
            default: _withId(() => [
              _hoisted_21,
              _hoisted_22
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_23, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'Sirens' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('Sirens') ? 'hidden' : '',
            ]],
            to: "/siren"
          }, {
            default: _withId(() => [
              _hoisted_24,
              _hoisted_25
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_26, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'Jin' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('Jin') ? 'hidden' : '',
            ]],
            to: "/jin"
          }, {
            default: _withId(() => [
              _hoisted_27,
              _hoisted_28
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_29, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'JinCategories' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('JinCategories') ? 'hidden' : '',
            ]],
            to: "/jin-categories"
          }, {
            default: _withId(() => [
              _hoisted_30,
              _hoisted_31
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_32, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'SeaMap' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('SeaMap') ? 'hidden' : '',
            ]],
            to: "/maps/sea-map"
          }, {
            default: _withId(() => [
              _hoisted_33,
              _hoisted_34
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_35, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'WaterMap' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('WaterMap') ? 'hidden' : '',
            ]],
            to: "/maps/water-map"
          }, {
            default: _withId(() => [
              _hoisted_36,
              _hoisted_37
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_38, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'ObservatoryMap' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('ObservatoryMap') ? 'hidden' : '',
            ]],
            to: "/maps/observatory-map"
          }, {
            default: _withId(() => [
              _hoisted_39,
              _hoisted_40
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_41, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'Fishing Knots' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('Fishing Knots') ? 'hidden' : '',
            ]],
            to: "/fishing-knots"
          }, {
            default: _withId(() => [
              _hoisted_42,
              _hoisted_43
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_44, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'Fishing Knot Category'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              !_ctx.permissions.includes('Fishing Knot Category') ? 'hidden' : '',
            ]],
            to: "/fishing-knot-categories"
          }, {
            default: _withId(() => [
              _hoisted_45,
              _hoisted_46
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_47, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'AppPush' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('AppPush') ? 'hidden' : '',
            ]],
            to: "/app-pushes/add"
          }, {
            default: _withId(() => [
              _hoisted_48,
              _hoisted_49
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _hoisted_50,
      _createVNode("ul", _hoisted_51, [
        _createVNode("li", _hoisted_52, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'UsinSubscription' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('UsinSubscription') ? 'hidden' : '',
            ]],
            to: "/usin/subscription"
          }, {
            default: _withId(() => [
              _hoisted_53,
              _hoisted_54
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _hoisted_55,
      _createVNode("ul", _hoisted_56, [
        _createVNode("li", _hoisted_57, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'Partners' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('Partners') ? 'hidden' : '',
            ]],
            to: "/partners-member"
          }, {
            default: _withId(() => [
              _hoisted_58,
              _hoisted_59
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'PartnersBooking' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('PartnersBooking') ? 'hidden' : '',
            ]],
            to: "/partners/booking"
          }, {
            default: _withId(() => [
              _hoisted_60,
              _hoisted_61
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'PartnersProduct' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('PartnersProduct') ? 'hidden' : '',
            ]],
            to: "/partners-product"
          }, {
            default: _withId(() => [
              _hoisted_62,
              _hoisted_63
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'PartnersFishingResult'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              !_ctx.permissions.includes('PartnersFishingResult') ? 'hidden' : '',
            ]],
            to: "/partners/fishing-result"
          }, {
            default: _withId(() => [
              _hoisted_64,
              _hoisted_65
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'PartnersNotice' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('PartnersNotice') ? 'hidden' : '',
            ]],
            to: "/partners-notice"
          }, {
            default: _withId(() => [
              _hoisted_66,
              _hoisted_67
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'PartnersPost' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('PartnersPost') ? 'hidden' : '',
            ]],
            to: "/partners-post"
          }, {
            default: _withId(() => [
              _hoisted_68,
              _hoisted_69
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'PartnersPostCategory'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              !_ctx.permissions.includes('PartnersPostCategory') ? 'hidden' : '',
            ]],
            to: "/partners-post-category"
          }, {
            default: _withId(() => [
              _hoisted_70,
              _hoisted_71
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'PartnersFishCode' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('PartnersFishCode') ? 'hidden' : '',
            ]],
            to: "/partners-fish-code"
          }, {
            default: _withId(() => [
              _hoisted_72,
              _hoisted_73
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'PartnersCommonCode'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              !_ctx.permissions.includes('PartnersCommonCode') ? 'hidden' : '',
            ]],
            to: "/partners-common-code"
          }, {
            default: _withId(() => [
              _hoisted_74,
              _hoisted_75
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _hoisted_76,
      _createVNode("ul", _hoisted_77, [
        _createVNode("li", _hoisted_78, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'CommerceSellerIndex'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              // !permissions.includes('JiCommerceSellerIndex') ? 'hidden' : '',
            ]],
            to: "/commerce/seller"
          }, {
            default: _withId(() => [
              _hoisted_79,
              _hoisted_80
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_81, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'CommerceProductList'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              // !permissions.includes('JiCommerceSellerIndex') ? 'hidden' : '',
            ]],
            to: "/commerce/product"
          }, {
            default: _withId(() => [
              _hoisted_82,
              _hoisted_83
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_84, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'CommerceCategoryIndex'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              // !permissions.includes('JiCommerceSellerIndex') ? 'hidden' : '',
            ]],
            to: "/commerce/product-category"
          }, {
            default: _withId(() => [
              _hoisted_85,
              _hoisted_86
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_87, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'CommerceProductPromotion'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              // !permissions.includes('JiCommerceSellerIndex') ? 'hidden' : '',
            ]],
            to: "/commerce/promotion"
          }, {
            default: _withId(() => [
              _hoisted_88,
              _hoisted_89
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_90, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'CommerceOrderIndex'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              // !permissions.includes('JiCommerceSellerIndex') ? 'hidden' : '',
            ]],
            to: "/commerce/order"
          }, {
            default: _withId(() => [
              _hoisted_91,
              _hoisted_92
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_93, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'CommerceContractIndex'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              // !permissions.includes('JiCommerceSellerIndex') ? 'hidden' : '',
            ]],
            to: "/commerce/contract"
          }, {
            default: _withId(() => [
              _hoisted_94,
              _hoisted_95
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_96, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'CommercePlacingOrderAfterCIndex'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              // !permissions.includes('JiCommerceSellerIndex') ? 'hidden' : '',
            ]],
            to: "/commerce/placing-order-after"
          }, {
            default: _withId(() => [
              _hoisted_97,
              _hoisted_98
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _hoisted_99,
      _createVNode("ul", _hoisted_100, [
        _createVNode("li", _hoisted_101, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'UserManagement' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('UserManagement') ? 'hidden' : '',
            ]],
            to: "/user-management"
          }, {
            default: _withId(() => [
              _hoisted_102,
              _hoisted_103
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_104, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'UsinUserManagement'
                ? _ctx.activeClass
                : _ctx.inactiveClass,
              !_ctx.permissions.includes('UsinUserManagement') ? 'hidden' : '',
            ]],
            to: "/usin-user-management"
          }, {
            default: _withId(() => [
              _hoisted_105,
              _hoisted_106
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_107, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'User Reports' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('User Reports') ? 'hidden' : '',
            ]],
            to: "/user-report"
          }, {
            default: _withId(() => [
              _hoisted_108,
              _hoisted_109
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _hoisted_110,
      _createVNode("ul", _hoisted_111, [
        _createVNode("li", _hoisted_112, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'AdminAccount' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('AdminAccount') ? 'hidden' : '',
            ]],
            to: "/admin-account"
          }, {
            default: _withId(() => [
              _hoisted_113,
              _hoisted_114
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_115, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'AdminRoles' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('AdminRoles') ? 'hidden' : '',
            ]],
            to: "/admin-roles"
          }, {
            default: _withId(() => [
              _hoisted_116,
              _hoisted_117
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _hoisted_118,
      _createVNode("ul", _hoisted_119, [
        _createVNode("li", _hoisted_120, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'RewardCommonCode' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('PartnersJoin') ? 'hidden' : '',
            ]],
            to: "/reward-common-code"
          }, {
            default: _withId(() => [
              _hoisted_121,
              _hoisted_122
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _hoisted_123,
      _createVNode("ul", _hoisted_124, [
        _createVNode("li", _hoisted_125, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'FishingTubes' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('FishingTubes') ? 'hidden' : '',
            ]],
            to: "/fishing-tubes"
          }, {
            default: _withId(() => [
              _hoisted_126,
              _hoisted_127
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_128, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'ProPost' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('ProPost') ? 'hidden' : '',
            ]],
            to: "/pro-post"
          }, {
            default: _withId(() => [
              _hoisted_129,
              _hoisted_130
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_131, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'ProPostCategories' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('ProPostCategories') ? 'hidden' : '',
            ]],
            to: "/pro-post-categories"
          }, {
            default: _withId(() => [
              _hoisted_132,
              _hoisted_133
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_134, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'Ask' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('Ask') ? 'hidden' : '',
            ]],
            to: "/ask"
          }, {
            default: _withId(() => [
              _hoisted_135,
              _hoisted_136
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode("li", _hoisted_137, [
          _createVNode(_component_router_link, {
            class: ["c-sidebar-nav-link", [
              _ctx.$route.name === 'AskCategories' ? _ctx.activeClass : _ctx.inactiveClass,
              !_ctx.permissions.includes('AskCategories') ? 'hidden' : '',
            ]],
            to: "/ask-categories"
          }, {
            default: _withId(() => [
              _hoisted_138,
              _hoisted_139
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ])
    ])
  ]))
})